export const dashboardMenu = [
  { label: "Tableau de bord", link: "/dashboard", icon: "ri-dashboard-line" },
  { label: "Documents", link: "/documents", icon: "ri-file-text-line" },
  { label: "Catégories", link: "/categories", icon: "ri-price-tag-3-line" },
  { label: "Sources", link: "/sources", icon: "ri-building-line" },
  { label: "Tags", link: "/tags", icon: "ri-hashtag" },
  { label: "Statistiques", link: "/statistics", icon: "ri-bar-chart-box-line" },
];

export const pagesMenu = [
  { label: "Mon profil", link: "/profile", icon: "ri-user-line" },
];